// Connect Sass
require("./scss/index.scss");

// Connect SVG Sprite
// function requireAll(r) {
//   r.keys().forEach(r);
// }
//requireAll(require.context("./assets/images/sprite", true, /\.svg$/));

// Loading
window.addEventListener("load", () => {
  document.body.classList.remove("before-load");

  document.querySelector(".loading").addEventListener("transitionend", (e) => {
    document.body.removeChild(e.currentTarget);
  });
});

// jQuery
window.jQuery = window.$ = require("jquery");

// Aside Nav
let asideNavElements = () => {
  if ($(".aside__nav").length) {
    var asideNav = $(".aside__nav"),
      asideNavLink = asideNav.find(".aside__navLink:not(:only-child)");

    asideNavLink.each(function () {
      $(this).on("click", function (event) {
        var asideNavSubLists = $(this).next(".aside__navSubList"),
          asideNavSubListSiblings = asideNavLink.not(this).next(".aside__navSubList");

        $(this).toggleClass("is-active");
        asideNavLink.not(this).removeClass("is-active");
        asideNavSubLists.stop().slideToggle(350);
        asideNavSubListSiblings.slideUp(350);
        event.preventDefault();
      });
    });
  }
};

// Header, Aside , Footer Fixed - ScrollLeft
let fixedElements = () => {
  if ($(".header, .aside, .footer").length) {
    var fixedScrollLeft = $(".header, .aside, .footer");
    fixedScrollLeft.css("left", $(document).scrollLeft() * -1);
  }
};

// TOAST Pagination
window.Pagination = require("tui-pagination");
//require('tui-pagination/dist/tui-pagination.min.css');

// TOAST Select
// window.SelectBox = require("@toast-ui/select-box");
// require("@toast-ui/select-box/dist/toastui-select-box.min.css");
// window.selectStyle = {
//   "common.width": "100%",
//   "common.padding": "0 10px",
//   "common.border": "1px solid #F0F0F0",
//   "common.borderRadius": "4px",
//   "common.backgroundColor": "#fff",
//   "common.outline": "none",
//   "common.fontSize": "14px",
//   "common.color": "#373737",
//   "common.disabled.border": "1px solid #f0f0f0",
//   "common.disabled.backgroundColor": "#FBFBFB",
//   "common.disabled.color": "#c0c0c0",

//   "dropdown.maxHeight": "124px",
//   "dropdown.border": "1px solid #980ED8",
//   "dropdown.borderTop": "1px solid #980ED8",
//   "dropdown.marginTop": "-1px",
//   "dropdown.padding": "3px",
//   "dropdown.zIndex": "99",

//   "input.height": "38px",
//   "input.focus.borderColor": "#980ED8",

//   "item.height": "37px",
//   "item.padding": "0 10px",
//   "item.selected.backgroundColor": "#FBF3FF",
//   "item.highlighted.backgroundColor": "#FBF3FF",
// };

//TOAST Date Picker
window.DatePicker = require("tui-date-picker");
require("tui-date-picker/dist/tui-date-picker.min.css");

//TOAST Grid
window.Grid = require("tui-grid");
require("tui-grid/dist/tui-grid.min.css");
window.gridStyle = {
  row: {
    hover: {
      background: "#FBF3FF",
    },
  },
  selection: {
    background: "#C66FEE",
    border: "#C66FEE",
  },
  scrollbar: {
    border: "transparent",
    background: "transparent",
    thumb: "#D9D9D9",
    emptySpace: "transparent",
    active: "#B3B3B3",
  },
  cell: {
    normal: {
      background: "#fff",
      border: "#F0F0F0",
      showVerticalBorder: false,
      text: "#373737",
    },
    header: {
      background: "#fff",
      border: "#373737",
      showVerticalBorder: false,
      showHorizontalBorder: true,
      text: "#B3B3B3",
    },
    selectedHeader: {
      background: "#FBF3FF",
      border: "#FBF3FF",
    },
    selectedRowHeader: {
      background: "#fff",
    },
    focused: {
      border: "#980ED8",
    },
    focusedInactive: {
      border: "#980ED8",
    },
    disabled: {
      background: "#F0F0F0",
      text: "#C0C0C0",
    },
    required: {
      background: "rgba(13, 177, 185,0.05)",
    },
    invalid: {
      background: "rgba(13, 177, 185,0.1)",
    },
  },
};

// input, search clear
let inputClear = () => {
  let formControlInput = $(".formControl__input,.formControl__search");
  let formControlClear = $(".formControl__clear");
  let searchBtn = $(".formControl__searchBtn");
  formControlInput
    .on("input propertychange", function () {
      var $this = $(this);
      var visible = Boolean($this.val());
      $this.siblings(formControlClear).not(searchBtn).toggleClass("is-none", !visible);
      //$this.toggleClass("is-defalut", !visible);
    })
    .trigger("propertychange");
  formControlClear.on("click", function () {
    $(this).siblings("input").val("").trigger("propertychange").focus();
  });
};

// Scroll
window.addEventListener("scroll", function () {
  fixedElements();
});

// DOMContentLoaded
window.addEventListener("DOMContentLoaded", function () {
  asideNavElements();
  inputClear();
});
